import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import InstitutionUsage from '../components/InstitutionUsage';
import { RootState } from '../store/configureStore';
import * as StatisticsActions from '../actions/Statistics/actions';

function mapStateToProps(state: RootState) {
  return {
    auth: state.auth,
    statistics: state.statistics,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    statisticsActions: bindActionCreators(StatisticsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionUsage);
